(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/jackpots/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/components/numbergames/jackpots/assets/javascripts/constants.js');

'use strict';

const JACKPOT_WINSET = {
  LOTTO_1: 0,
  LOTTO_2: 1,
  DROMVINST: 2
};
const JACKPOT_WINDIV = {
  PRIMARY: 0,
  SECONDARY: 1
};
if (svs.isServer) {
  module.exports = {
    JACKPOT_WINSET,
    JACKPOT_WINDIV
  };
} else {
  svs.numbergames.jackpot.CONSTANTS = {
    JACKPOT_WINSET,
    JACKPOT_WINDIV
  };
}

 })(window);